import {
  base_colorAction,
  base_colorContentBorder,
  base_contentHover,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  border-bottom: 1px solid ${base_colorContentBorder};

  .SettingsDisclosure-header {
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: ${spacing(4)};
    padding: ${spacing(3)} ${spacing(2)};
    border: none;
    background: none;
    border-radius: ${spacing(2)};
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .SettingsDisclosure-header:hover {
    background-color: ${base_contentHover};
  }

  .SettingsDisclosure-header:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 1px;
  }

  .SettingsDisclosure-titleCol {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    min-width: 0;
  }

  .SettingsDisclosure-title {
    font-family: ${font_family_weight_medium};
    ${font_md};
    letter-spacing: -0.005em;
    color: ${text_colorTextPrimary};
  }

  .SettingsDisclosure-summary {
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .SettingsDisclosure-action {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: ${spacing(2)};
  }

  .SettingsDisclosure-actionLabel {
    font-family: ${font_family_weight_medium};
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .SettingsDisclosure-chevron {
    display: inline-flex;
    color: ${text_colorTextSecondary};
    transition: transform 0.15s ease;
  }

  .SettingsDisclosure-chevron.open {
    transform: rotate(180deg);
  }

  .SettingsDisclosure-content {
    padding: 0 ${spacing(2)} ${spacing(4)};
  }

  @media (prefers-reduced-motion: reduce) {
    .SettingsDisclosure-header,
    .SettingsDisclosure-chevron {
      transition: none;
    }
  }
`
